import React from 'react';
import { Link } from "react-router-dom";

import "../styles/HowToPlay.css";

let isIE = /*@cc_on!@*/false || !!document.documentMode;

var HowToPlay = () => (
  <div className="howtoplay">
  <img className="background" src={require("../assets/bg-image-home.jpg")} alt="Background" />
  <img className="header" src={require("../assets/header-footer-colours.jpg")} alt="Header" />
    <h1 className="pageTitle">HowToPlay</h1>
    <img className="pqLogo" src={require("../assets/power-quiz-logo.png")} alt="Power Quiz Logo" />
    <img className="asLogo" src={require("../assets/ageScotlandLogo.png")} alt="ageScotland Logo" /><div className="howTo">
    <div className="instructions">
      <div className="instruction">
        <img className="bingoBall" src={require("../assets/bingo-balls/bingo-ball_01.png")} alt="Instruction 1" /><p>Form one or more quiz teams and choose team names. Or play as individuals.</p>
      </div>
      <div className="instruction">
        <img className="bingoBall" src={require("../assets/bingo-balls/bingo-ball_02.png")} alt="Instruction 2" /><p>Always start with a warm-up of gentle marching.</p>
      </div>
      <div className="instruction">
        <img className="bingoBall" src={require("../assets/bingo-balls/bingo-ball_03.png")} alt="Instruction 3" /><p>Answer multiple choice questions in four rounds: sport, entertainment, around the world, and history.</p>
      </div>
      <div className="instruction">
        <img className="bingoBall" src={require("../assets/bingo-balls/bingo-ball_04.png")} alt="Instruction 4" /><p>Reveal the answer, play the video and start moving to the music. Each exercise is demonstrated.</p>
      </div>
      <div className="instruction">
        <img className="bingoBall" src={require("../assets/bingo-balls/bingo-ball_05.png")} alt="Instruction 5" /><p>There are four quizzes for you to play. After that, make up your own with My Quiz.</p>
      </div>
    </div>
    </div>    
    <Link className="begin button" to="/disclaimer">BEGIN</Link>         
    <img className="footer" src={require("../assets/header-footer-colours.jpg")} alt="Footer" />
  </div>
);

if(isIE){
  HowToPlay = () => (
    <div className="ie-howtoplay">
      <div className="header-footer">
        <img className="header" src={require("../assets/header-footer-colours.jpg")} alt="Header" />
      </div>
      <div className="pageContent">
        <div className="heading">
          <h1>HowToPlay</h1>
          <div className="logos">
            <img className="pqLogo" src={require("../assets/power-quiz-logo.png")} alt="Power Quiz Logo" />
            <img className="asLogo" src={require("../assets/ageScotlandLogo.png")} alt="ageScotland Logo" />
          </div>
        </div>
        <div className="howTo">
          <div className="instructions">
            <div className="instruction">
              <img className="bingoBall" src={require("../assets/bingo-balls/bingo-ball_01.png")} alt="Instruction 1" /><p>Form one or more quiz teams and choose team names.</p>
            </div>
            <div className="instruction">
              <img className="bingoBall" src={require("../assets/bingo-balls/bingo-ball_02.png")} alt="Instruction 2" /><p>Always start with a warm-up of gentle marching.</p>
            </div>
            <div className="instruction">
              <img className="bingoBall" src={require("../assets/bingo-balls/bingo-ball_03.png")} alt="Instruction 3" /><p>Answer multiple choice questions in four rounds: sport, entertainment, around the world, and history.</p>
            </div>
            <div className="instruction">
              <img className="bingoBall" src={require("../assets/bingo-balls/bingo-ball_04.png")} alt="Instruction 4" /><p>For each answer there’s an associated exercise.  Watch the demonstration videos to see you how do it.</p>
            </div>
            <div className="instruction">
              <img className="bingoBall" src={require("../assets/bingo-balls/bingo-ball_05.png")} alt="Instruction 5" /><p>When the exercise demonstration is over, click ‘Music’ on the right and repeat the same exercise in time with the music.</p>
            </div>
          </div>
        </div>  
        <div className="action">
          <Link className="button begin" to="/disclaimer">BEGIN</Link>
        </div>        
      </div>  
      <div className="header-footer">
        <img className="footer" src={require("../assets/header-footer-colours.jpg")} alt="Header" />
      </div>
    </div>
  );
} 

export default HowToPlay;
